import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l } from "@tanstack/react-query";
//#region src/Client.ts
var u = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7078/Pdf";
	}
	preparePdfForEditing(e, t) {
		let r = this.baseUrl + "/PreparePdfForEditing", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/pdf",
				Accept: "application/pdf"
			},
			data: e,
			responseType: "blob",
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processPreparePdfForEditing(e)));
	}
	async processPreparePdfForEditing(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t])), n = e.data instanceof Blob && (e.status < 200 || e.status >= 300) ? await e.data.text() : e.data;
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? f("No description", e.status, n, t) : e.status === 204 ? Promise.resolve(null) : f("An unexpected server error occurred.", e.status, n, t);
	}
}, d = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isPdfApiException = !0;
	static isPdfApiException(e) {
		return e.isPdfApiException === !0;
	}
};
function f(e, t, n, r, i) {
	throw i ?? new d(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var p = "pdf";
function m(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var h = (e, t, n) => {
	let r = new u(e);
	return r.setAuthConfig(t, n), m(r);
}, g = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.pdf || `${e}/pdf`;
}, _ = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = g(i), u = c, d = h(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, _;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = h(l, a, i);
		p(e);
	}, _ = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = _) : (m = n[8], _ = n[9]), s(m, _), f;
}, v = a({}), y = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = _(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(v.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, b = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(v), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.preparePdfForEditing(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		preparePdfForEditing: d,
		preparePdfForEditingPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
};
//#endregion
export { v as PdfApiContext, d as PdfApiException, y as PdfApiProvider, u as PdfClient, p as PdfRoute, _ as usePdfClientContext, b as usePreparePdfForEditing };
